import { Component, ElementRef, inject, isDevMode, OnDestroy, OnInit, ViewChild, Input, TemplateRef } from '@angular/core'
import { LocationStrategy, NgClass, ViewportScroller } from '@angular/common';
import { ActivatedRoute, ActivationEnd, ActivationStart, NavigationEnd, RouterEvent } from '@angular/router'
import { slideInUpOnEnterAnimation, slideOutDownOnLeaveAnimation } from 'angular-animations'

import { HomeComponent } from '../home/home.component'
import { LibraryComponent } from '../library/library.component'
import { PerformanceComponent, PerformanceNavigation } from '../performance/performance.component'

import { FooterlteComponent } from "./footerlte/footerlte.component"
import { HeaderlteComponent } from "./headerlte/headerlte.component"

import { HeaderComponent } from "./content-header/content-header.component"
import { ProfileComponent } from "../profile/profile.component"

import { NavigationBarState } from '../navigationbar/navigationbar.component'

import { DrawerState } from '../drawer/drawer.component'
import { LegalComponent, LegalType } from "../legal/legal.component"
import { isActiveClassroom, isResultClassroom, isSuccessClassroom, JoinClassroomComponent, JoinClassroomState } from '../join-classroom/join-classroom.component';
import { _defaultSearchState, ResponsiveComponent, RouterLifecycleEvent, SnackbarComponent, UpdateService } from '@nx-superprep/shared'
import { NgCircleProgressModule } from 'ng-circle-progress'
import { DateOnly, log } from '@nx-superprep/utils'
import { HeaderTemplateType, LibraryNavigation, LongtailService, PrivateUserInfo, StudyService, UserInfo, UserService } from '@nx-superprep/backend/firebase'

import { _defaultTabState, _defaultNavigationState, _defaultDrawerStates } from '../@shared'
import { distinctUntilChanged, Subject, takeUntil } from 'rxjs'
import { TourService } from 'ngx-ui-tour-md-menu'
import { getTours, getTourSteps, Tours } from './tour-steps'
import { MatButtonModule } from '@angular/material/button'
import { MatMenuModule } from '@angular/material/menu'
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar'
import { MatSidenavModule } from '@angular/material/sidenav'
import { MatDividerModule } from '@angular/material/divider'
import { AvatarComponent } from '../avatar/avatar.component'
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal'
import { LessonTile } from '@nx-superprep/study'
import { isEqual } from 'lodash-es'
import { CookieBannerComponent } from "../legal/cookie-banner/cookie-banner.component";

@Component({
  selector: 'pop-ui-dashboard',
  standalone: true,
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  queries: {
    tabsContentTopRef: new ViewChild("tabsContentTopRef"),
    tabsContentRef: new ViewChild("tabsContentRef"),
    "confirmLogout": new ViewChild("_confirmLogout"),
  },
  animations: [
    slideInUpOnEnterAnimation({ duration: 0, delay: 0 }),
    slideOutDownOnLeaveAnimation({ duration: 0, delay: 50 }),
  ],
  imports: [
    NgClass,
    HomeComponent,
    LibraryComponent,
    PerformanceComponent,
    HeaderlteComponent,
    FooterlteComponent,
    HeaderComponent,
    ProfileComponent,
    LegalComponent,
    NgCircleProgressModule,
    JoinClassroomComponent,
    MatButtonModule,
    MatMenuModule,
    MatSidenavModule,
    MatDividerModule,
    AvatarComponent,
    CookieBannerComponent
],
  providers: [BsModalService]
})
export class DashboardComponent extends ResponsiveComponent implements OnInit, OnDestroy {
  /* eslint-disable @typescript-eslint/no-unused-vars */
  override onFocus(event: FocusEvent): void { this.onReset(event) }
  override onVisibilityChange(event: Event): void {
    if (document.visibilityState === 'visible') {
      this.onReset('visible')
      if (this.activeTab === 'home') {
        this.activeDate = new DateOnly()
      }
   }}
  /* eslint-enable @typescript-eslint/no-unused-vars */

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onReset(_event: string | FocusEvent) {
    if (this._isResetting || !!this._classroom.status || isDevMode()) { return }
    this._isResetting = true
    this.updateService.check().then(() => this.resetView()).finally(() => this._isResetting = false)
  }

  onScrollEnd(event: Event) {
    const target = event.currentTarget as HTMLDivElement
    this.windowScrolled = this.tabsContentRef.nativeElement.getBoundingClientRect().top < target.getBoundingClientRect().top
    this.windowAtTop = (target.scrollTop >= 530)
    this.windowAtEnd = (target.offsetHeight + target.scrollTop >= target.scrollHeight)
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onHandlebarAction(event: any) {
    log.debug('handlebar action', event)
    if (this.windowScrolled) {
      this.scrollToTop()
    } else {
      this.scrollTo(0, event.y - 120)
    }
  }

  public tabsContentTopRef!: ElementRef
  public tabsContentRef!: ElementRef

  private _isMenuOpen = false
  public get isMenuOpen() {
    return !this.isWeb && this._isMenuOpen
  }
  public set isMenuOpen(value) {
    if (this._isMenuOpen === value) { return }
    this._isMenuOpen = value
  }

  get entries(): [HeaderTemplateType[], string[]] {
    return [
      this.userService.headerTemplateValues,
      ['Settings', 'Privacy', 'Terms of use', 'Sign Out']
      //['Settings', 'Help', 'Report a Bug', 'Suggestion Box', 'Sign Out']
    ]
  }

  public confirmLogout!: TemplateRef<unknown>
  private _bsModalRef!: BsModalRef
  readonly modalService = inject(BsModalService)

  confirm() {
    this._bsModalRef?.hide()
    this._bsModalRef = this.modalService.show(this.confirmLogout, {animated:true, class:'modal-md signout-modal'})
  }

  onSelect(item?: HeaderTemplateType | string) {
    this.isMenuOpen = false
    if (!item) { return }
    if (this.entries[1].includes(item)) {
      switch (item) {
        case 'Settings': this.profile = true; break
        case 'Privacy': this.legal = 'privacy'; break
        case 'Terms of use': this.legal = 'tacos'; break
        case 'Help': log.debug('help'); break
        case 'Report a Bug': log.debug('report-bug'); break
        case 'Suggestion Box': log.debug('suggestion-box'); break
        case 'Sign Out': this.userService.signOut(); break
        default: log.debug('unknown', item)
       }
    } else {
      this._bsModalRef?.hide()
      this.activeTab = item as HeaderTemplateType
    }
  }

  title(id: string) {
    switch (id) {
      case 'home': return 'Home'
      case 'library': return 'Explore'
      case 'performance': return 'Performance'
      case 'brushup': return 'Brushup'
      case 'join': return 'Classroom Join Code'
      default: return id.toTitleCase()
    }
  }

  windowScrolled = false
  windowAtTop = false
  windowAtEnd = false

  template: HeaderTemplateType = 'home'
  userInfo: UserInfo & PrivateUserInfo | null = null

  private _defaultActiveTab: HeaderTemplateType =  this.isInFrame ? 'library' : 'home'
  private _isResetting = false

  private _activeDate = new DateOnly()
  public get activeDate(): DateOnly {
    return this._activeDate
  }
  public set activeDate(value: DateOnly) {
    if (value.isSame(this._activeDate) || this.slideUp) { return }
    this._activeDate = value
  }

  private _navigation: NavigationBarState = _defaultNavigationState
  get navigation() { return this._navigation; }
  set navigation(value) {
    if (value.action === 'back' && this.tabState.parent) {
      this.tabState = this.tabState.parent
    } else {
      this.resetView(true)
      this._navigation = value
    }
    this._navigation.segments = this.segments
  }

  get segments() {
    const _segments: {path: string, title: string}[] = []
    for(let t = this.tabState; t.parent; t = t.parent) {
      _segments.splice(0, 0, ({
        path: t.navigation.current.route,
        title: t.navigation.current.title ?? t.selection?.item?.title ?? t.navigation.current.route
      }))
    }
    return _segments
  }

  // home state needs some special handling for the drawer content
  private _homeState: DrawerState = _defaultDrawerStates('empty')
  get homeState() { return this._homeState }
  set homeState(value) {
    this._homeState = value
    this.scrollToTop(true)
  }
  // other states are just a list of tabs
  private _tabState: LibraryNavigation | PerformanceNavigation = _defaultTabState
  get tabState() { return this._tabState }
  set tabState(value) {
    let collapsed = false
    let title = value.navigation.current.route as string
    if (value.selection) {
      if ('lesson' in value.selection) {
        title = value.selection.lesson ?? title
      }
      if ('section' in value.selection) {
        title = value.selection?.section?.title ?? title
      }
      if (value.selection?.item) {
        title = value.selection.item.title ?? title
        collapsed = ('cardCount' in value.selection.item)
      }
    }
    this.collapsed = collapsed
    this._tabState = {...value}
    this._navigation = {...this._tabState.navigation, title, segments: this.segments}
    if (!['lessons', 'graph'].includes(value.navigation.current.route)) { this.resetView(true) }
    if (value.navigation.current.route === 'brushup') { this.router.navigate(['/brushup'], { replaceUrl:true, skipLocationChange: true }) }
    if (value.navigation.current.route === 'resources') { this.router.navigate(['/resources'], { replaceUrl:true, skipLocationChange: true }) }
  }

  @Input()
  get activeTab() { return this.template ?? this._defaultActiveTab }
  set activeTab(value) {
    this.tabState = { navigation: { current: { route: value, type: 'root' }}}
    if (this.template !== value) { this.longtailService.logPageView(value, `${window.location.href}${value}`, `/${value}`) }
    this.template = value
    this.location.pushState({activeTab: value}, '', '/', '')
  }

  get isJoinActive() {
    return isActiveClassroom(this.classroom)
  }

  private _classroom: JoinClassroomState = {status:undefined}
  get classroom() { return this._classroom }
  set classroom(value) {
    if (value.status === this._classroom.status) { return }
    this.profile = false
    this.scrollToTop()
    this._classroom = value
    this.activeDate = new DateOnly()
    if (this.isJoinActive) {
      this.longtailService.logPageView('join', `${window.location.href}`, `/join`)
    } else {
      this.onJoinClass(this._classroom)
    }
  }

  private _feedback = false
  get feedback() { return this._feedback }
  set feedback(value) {
    if (value === this._profile) { return }
    this.isMenuOpen = false
    this.classroom = {status:undefined}
    this.scrollToTop(value)
    this._feedback = value
    this.activeDate = new DateOnly()
    if (this._feedback) { this.longtailService.logPageView('feedback', `${window.location.href}`, `/feedback`) }
  }

  private _profile = false
  get profile() { return this._profile }
  set profile(value) {
    if (value === this._profile) { return }
    this.isMenuOpen = false
    this.classroom = {status:undefined}
    this.scrollToTop(value)
    this._profile = value
    this.activeDate = new DateOnly()
    if (this._profile) { this.longtailService.logPageView('profile', `${window.location.href}`, `/profile`) }
  }

  private _legal: LegalType|undefined = undefined
  get legal() { return this._legal }
  set legal(value) {
    this.profile = false
    this.scrollToTop(!!value)
    this._legal = value ? ['tacos','privacy'].includes(value) ? value : undefined : undefined
    if (this._legal) { this.longtailService.logPageView('legal', `${window.location.href}`, `/${value}`) }
  }

  private _tiles: LessonTile[] = [] as LessonTile[]
  get tiles() {
    return this._tiles
  }
  set tiles(value) {
    if (isEqual(value, this._tiles)) { return }
    this._tiles = value
    this.checkForTour()
  }
  get isTourVisible() { return this.userService.isContentManager }
  get isSearchVisible() { return ['home','library'].includes(this.activeTab) || (['performance'].includes(this.activeTab) && this.segments.length < 1) }
  get isHeaderVisible() { return (this.isWeb || !this.isHome) && (!this.isHome || !this.homeState.contentState.selected) }
  get isFooterVisible() { return false /*this.isWeb && this.windowAtEnd*/ }
  get slideUp() { return this.profile || this.legal || this.isJoinActive }
  get isHome() { return this.activeTab === 'home' }
  override get isDark() { return !this.isWeb && this.isHome && !this.windowAtEnd }

  resetView(scrollToTop = false) {
    this.classroom = {status:undefined}
    this.isMenuOpen = false
    this.profile = false
    this.legal = undefined
    this.search = { ...this.search, visible: this.isSearchVisible, selected: undefined }
    this.activeDate = new DateOnly()
    this.isScrollable = true
    this.homeState.contentState.lesson = undefined
    this.homeState.contentState.selected = undefined
    this.scrollToTop(scrollToTop)
    if (!this.isWeb && !isDevMode()) { this.orientationService.lockOrientation('portrait-primary', false) }
  }

  scrollToTop(value = true) {
    if (value) { this.scrollTo(0,0) }
  }

  scrollTo(x: number, y: number) {
    this.tabsContentTopRef?.nativeElement?.scrollTo( x, y )
    this.windowScrolled = y > 0
  }

  private readonly _snackBarRef = inject(MatSnackBar);
  onJoinClass(result: JoinClassroomState) {
    if (!isResultClassroom(result)) { return }
    this._activeDate = new DateOnly()
    const _options = {
      panelClass: 'header-snackbar',
      horizontalPosition: 'start' as MatSnackBarHorizontalPosition,
      verticalPosition: 'top' as MatSnackBarVerticalPosition,
      duration: 3000,
      data: {
        type: 'header',
        title: isSuccessClassroom(result) ? 'Success' : 'Failed',
        subTitle: `${result.classroomName}. ${result.error ? result.error?.message : 'Your classroom units will soon appear on your dashboard'}.`,
        imageUrl: '/assets/img/icons/new@3x.webp',
        error: result.error,
      },
    }
    setTimeout(() =>
    this._snackBarRef.openFromComponent(SnackbarComponent, _options).afterDismissed().subscribe((a) => {
      log.debug(`${result.classroomName} ${result.teacherName} ${a.dismissedByAction ? 'dismissed':'not dismissed'}`)
      this._classroom = {status:undefined}
    }))
  }

  override onPopstate(event: PopStateEvent) {
    super.onPopstate(event)
    //const tabIndex = this.userService.headerTemplateValues.findIndex(t => t === event.state.activeTab) || 0
    //const tab = tabIndex > 0 ? this.userService.headerTemplateValues[tabIndex] : 'home'
    if (this.tabState.selection) {
      if (this.tabState.parent) {
        this.tabState = {navigation:this.tabState.parent.navigation}
      }
    } else {
      //this.confirm()
    }
  }

  override onRouterEvent(event: RouterLifecycleEvent | RouterEvent): void {
    super.onRouterEvent(event)
    if (event instanceof ActivationStart) {
      log.debug('activationStart', event)
      this.tourService.end()
    }
    if (event instanceof ActivationEnd) {
      this.activeTab ??= this.route.snapshot.params['activeTab'] ?? this.route.snapshot.queryParams['activeTab'] ?? this._defaultActiveTab
      this.location.replaceState({activeTab:this.activeTab}, '', '/', '')
    }
    if (event instanceof NavigationEnd) {
      this.longtailService.logPageView('dashboard', event.url, '/home')
    }
  }

  override ngOnInit() {
    super.ngOnInit()
    this.userService.embedded = this.isInFrame
    this.search = _defaultSearchState
    this.resetView(true)
    this.activeTab = this.route.snapshot.params['activeTab'] ?? this.route.snapshot.queryParams['activeTab'] ?? this.route.snapshot.url[1]?.path ?? this._defaultActiveTab
    this.userService.getInfo().pipe(takeUntil(this.onDestroy)).subscribe(info => this.userInfo = info)
    this.longtailService.logPageView('dashboard', window.location.href, this.activeTab)
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy()
    this._bsModalRef?.hide()
    this.destroyTour$.next()
    this.destroyTour$.complete()
  }

  checkForTour() {
    if (!this.userService.activeUser || this.tiles.length === 0) { return }
    if (this.userService.isNew) {
      this.startTour(Tours.first_signup)
    }
    if (this.studyService.isSingleSessionExit) {
      const _tour = []
      if (this.studyService.isFirstSessionExit) { _tour.push(Tours.first_post_session) }
      if (this.studyService.isFirstLessonComplete) { _tour.push(Tours.first_lesson_complete) }
      this.startTour(_tour)
    }
  }

  private _isTourActive = false
  private destroyTour$ = new Subject<void>();

  startTour(tours: Tours|Tours[]) {
    if (this.activeTab !== 'home') { return } // Only start tour on home tab
    // End previous tour if active
    if (this._isTourActive) {
      this.destroyTour$.next(); // Ends existing subscriptions
    }
    this._isTourActive = true;
    this.tourService.initialize(getTourSteps(tours), {
      enableBackdrop: true,
      closeOnOutsideClick: true,
      backdropConfig: {
        offset: 10,
      },
    })
    this.tourService.start()

    // Subscribe to end of the tour, with cancellation
    this.tourService.end$
      .pipe(takeUntil(this.destroyTour$), distinctUntilChanged())
      .subscribe(() => {
        this._isTourActive = false;
        this.destroyTour$.next(); // Cleanup on tour end
      });

    // Subscribe to stepHide events with cancellation
    this.tourService.stepHide$
      .pipe(takeUntil(this.destroyTour$), distinctUntilChanged())
      .subscribe((change) => {
        const clicked = change.step.endBtnTitle === change.step.nextBtnTitle
        log.debug(change.step.anchorId, clicked, change)
        if (change.step.anchorId === 'anchor.centered.icon') {
          if (change.step.endBtnTitle === 'Go to Explore' && clicked) { this.activeTab = 'library' }
        }
      })
  }

  readonly tourService = inject(TourService);
  tours = getTours()

  readonly route = inject(ActivatedRoute)
  readonly studyService = inject(StudyService)
  readonly longtailService = inject(LongtailService)
  readonly updateService = inject(UpdateService)
  readonly location = inject(LocationStrategy)
  readonly userService = inject(UserService)
  readonly scroller = inject(ViewportScroller)

  constructor() {
    super()
    super.rootClassName = `dashboard-root-class-name ${this.embedded ? 'embedded' : ''}`
  }
}
